$select-background1:'#182A38' !default;
$select-background2:'#2A475B' !default;
$select-color:'#B7CFE2' !default;
$select-arrow-border-left:'#1B3241' !default;
$select-multi-color:'#B7CFE2' !default;
$select-multi-icon-background:'#111C27' !default;
$select-multi-value-background:'#192533' !default;


.Select.Select--single {
  .Select-control {
    background: linear-gradient(0deg, #{$select-background1}, #{$select-background2});
    color: #B7CFE2 !important;
    .Select-multi-value-wrapper {
      .Select-value {
        .Select-value-label {
          color: #{$select-color} !important;
        }
      }
    }
  }
}

.Select.Select--multi {
  .Select-control {
    background: linear-gradient(0deg, #{$select-background1}, #{$select-background2});
    color: #B7CFE2 !important;
    .Select-multi-value-wrapper {
      .Select-value {
        background: #{$select-multi-value-background};
        .Select-value-icon {
          color: #{$select-multi-color};
          background: #{$select-multi-icon-background};
        }
        .Select-value-label {
          color: #{$select-multi-color} !important;
        }
      }
    }
  }
}


.Select-placeholder {
  color: #{$select-color} !important;
}

.is-open > .Select-control {
  background: linear-gradient(0deg, #{$select-background1}, #{$select-background2});
}

.Select-arrow-zone {
  border-left: 2px solid #{$select-arrow-border-left};
}

.Select-menu-outer {
  background-color: #2C495D !important;
  border:1px solid #2C495D !important;
  &:after {
    border-bottom: solid 8px #2C495D !important;
    border-left: solid 8px transparent !important;
    border-right: solid 8px transparent !important;
  }
}

.Select-option {
  background-color: #2C495D !important;
  color: white !important;
}
.Select-option.is-focused {
  background-color: #5A6E7E !important;
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/select/select-theme.scss